/**
 * Umami, the hub's own audience measurement: no cookie, nothing leaves the VPS.
 *
 * Added from the bundle rather than written in public/index.html, which CRA
 * cannot make conditional: a build without the website id would ship the
 * placeholder as is, and the dev servers have no Umami to answer /analytics.
 * A same-origin script added this way is still 'self' for the CSP; it is not
 * an inline one.
 *
 * Caddy relays /analytics/script.js and /analytics/api/send to Umami. The tracker
 * follows the router's pushState on its own. `data-exclude-search` keeps query
 * strings out of Umami's tables, where /nouveau-mot-de-passe?token=… and
 * /confirmer-email?token=… would otherwise land.
 */
export function loadAudienceTracker(websiteId) {
  if (!websiteId) {
    return;
  }

  const script = document.createElement('script');
  script.defer = true;
  script.src = '/analytics/script.js';
  script.dataset.websiteId = websiteId;
  script.dataset.hostUrl = '/analytics';
  script.dataset.excludeSearch = 'true';
  document.head.appendChild(script);
}
